module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "row ls-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-md-8 col-lg-8 col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "row ls-lg-margin-bottom"
  }, [_c('h3', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('customers.main.customer_information')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|emailInUse'),
      expression: "'required|email|emailInUse'"
    }],
    ref: "email",
    class: {
      'material--active material--has-errors': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "label": "Email",
      "ico": "fa fa-envelope-o",
      "focused": "true",
      "data-vv-name": "email"
    },
    model: {
      value: (_vm.$parent.$data.email),
      callback: function($$v) {
        _vm.$parent.$data.email = $$v
      },
      expression: "$parent.$data.email"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customers.attributes.email')) + "\n          "), (_vm.errors.has('email')) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message-email"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has('email') && _vm.$parent.$data.email) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check-email"
  }) : _vm._e()]), _vm._v(" "), (!_vm.$parent.$data.id) ? _c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.password'))
    },
    attrs: {
      "type": "password",
      "ico": "fa fa-lock",
      "label": "Password",
      "data-vv-name": _vm.$t('customers.attributes.password')
    },
    model: {
      value: (_vm.$parent.$data.password),
      callback: function($$v) {
        _vm.$parent.$data.password = $$v
      },
      expression: "$parent.$data.password"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customers.attributes.password')) + "\n          "), (_vm.errors.has(_vm.$t('customers.attributes.password'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.password'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.password')) && _vm.$parent.$data.password) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('phone|required'),
      expression: "'phone|required'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.phone'))
    },
    attrs: {
      "type": "tel",
      "ico": "fa fa-phone",
      "maxlength": "16",
      "v-mask": _vm.$parent.$data.phoneMask,
      "data-vv-name": _vm.$t('customers.attributes.phone')
    },
    model: {
      value: (_vm.$parent.$data.fullPhone),
      callback: function($$v) {
        _vm.$parent.$data.fullPhone = $$v
      },
      expression: "$parent.$data.fullPhone"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customers.attributes.phone')) + "\n          "), (_vm.errors.has(_vm.$t('customers.attributes.phone'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.phone'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.phone')) && _vm.$parent.$data.fullPhone) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label ls-no-bold ls-text-xs ls-lg-margin-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.$data.isBusiness),
      expression: "$parent.$data.isBusiness"
    }],
    attrs: {
      "type": "checkbox",
      "name": "business_people",
      "disabled": _vm.$parent.$data.lockBusiness
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.isBusiness) ? _vm._i(_vm.$parent.$data.isBusiness, null) > -1 : (_vm.$parent.$data.isBusiness)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.$parent.$data.isBusiness,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.$parent.$data.isBusiness = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.$parent.$data.isBusiness = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$parent.$data.isBusiness = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('customers.main.register_as_legal_entity')) + "\n        ")])]), _vm._v(" "), (_vm.$parent.$data.isBusiness) ? _c('div', {
    staticClass: "row"
  }, [_c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.company_name'))
    },
    attrs: {
      "type": "text",
      "ico": "fa fa-building-o",
      "focused": "true",
      "data-vv-name": _vm.$t('customers.attributes.company_name'),
      "required": false
    },
    model: {
      value: (_vm.$parent.$data.companyName),
      callback: function($$v) {
        _vm.$parent.$data.companyName = $$v
      },
      expression: "$parent.$data.companyName"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customers.attributes.company_name')) + "\n          "), (_vm.errors.has(_vm.$t('customers.attributes.company_name'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.company_name'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.company_name')) && _vm.$parent.$data.company_name) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()]), _vm._v(" "), _c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.trade_name'))
    },
    attrs: {
      "type": "text",
      "ico": "fa fa-briefcase",
      "focused": "true",
      "data-vv-name": _vm.$t('customers.attributes.trade_name')
    },
    model: {
      value: (_vm.$parent.$data.tradeName),
      callback: function($$v) {
        _vm.$parent.$data.tradeName = $$v
      },
      expression: "$parent.$data.tradeName"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customers.attributes.trade_name')) + "\n          "), (_vm.errors.has(_vm.$t('customers.attributes.trade_name'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.trade_name'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.trade_name')) && _vm.$parent.$data.tradeName) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()]), _vm._v(" "), _c('MaterialInput', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('99.999.999/9999-99'),
      expression: "'99.999.999/9999-99'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cnpj'),
      expression: "'required|cnpj'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.cnpj'))
    },
    attrs: {
      "type": "tel",
      "ico": "fa fa-id-card",
      "maxlength": "18",
      "data-vv-name": _vm.$t('customers.attributes.cnpj'),
      "required": false
    },
    model: {
      value: (_vm.$parent.$data.cnpj),
      callback: function($$v) {
        _vm.$parent.$data.cnpj = $$v
      },
      expression: "$parent.$data.cnpj"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customers.attributes.cnpj')) + "\n          "), (_vm.errors.has(_vm.$t('customers.attributes.cnpj'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.cnpj'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.cnpj')) && _vm.$parent.$data.cnpj) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "ls-lg-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('customers.main.optional_personal_info')))]), _vm._v(" "), _c('div', [_c('MaterialInput', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('999.999.999-99'),
      expression: "'999.999.999-99'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:14|cpf|cpfInUse'),
      expression: "'min:14|cpf|cpfInUse'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.cpf'))
    },
    attrs: {
      "type": "tel",
      "maxlength": "14",
      "focused": "true",
      "ico": "fa fa-id-card-o",
      "required": false,
      "data-vv-name": _vm.$t('customers.attributes.cpf')
    },
    model: {
      value: (_vm.$parent.$data.cpf),
      callback: function($$v) {
        _vm.$parent.$data.cpf = $$v
      },
      expression: "$parent.$data.cpf"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('customers.attributes.cpf')) + "\n            "), (_vm.errors.has(_vm.$t('customers.attributes.cpf'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.cpf'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.cpf')) && _vm.$parent.$data.cpf) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "false"
    },
    slot: "ico-check"
  }) : _vm._e()]), _vm._v(" "), _c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('alpha_spaces|min:2'),
      expression: "'alpha_spaces|min:2'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.name'))
    },
    attrs: {
      "type": "text",
      "label": "Name",
      "ico": "fa fa-user-o",
      "required": false,
      "data-vv-name": _vm.$t('customers.attributes.name')
    },
    model: {
      value: (_vm.$parent.$data.name),
      callback: function($$v) {
        _vm.$parent.$data.name = $$v
      },
      expression: "$parent.$data.name"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('customers.attributes.name')) + "\n            "), (_vm.errors.has(_vm.$t('customers.attributes.name'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.name'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.name')) && _vm.$parent.$data.name) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.$parent.$data.isBusiness) ? _c('MaterialInput', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('999.999.999-99'),
      expression: "'999.999.999-99'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14|cpf|cpfInUse'),
      expression: "'required|min:14|cpf|cpfInUse'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.cpf'))
    },
    attrs: {
      "type": "tel",
      "maxlength": "14",
      "focused": "true",
      "ico": "fa fa-id-card-o",
      "data-vv-name": _vm.$t('customers.attributes.cpf')
    },
    model: {
      value: (_vm.$parent.$data.cpf),
      callback: function($$v) {
        _vm.$parent.$data.cpf = $$v
      },
      expression: "$parent.$data.cpf"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customers.attributes.cpf')) + "\n          "), (_vm.errors.has(_vm.$t('customers.attributes.cpf'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.cpf'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.cpf')) && _vm.$parent.$data.cpf) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "false"
    },
    slot: "ico-check"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.$parent.$data.isBusiness) ? _c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('alpha_spaces|min:2'),
      expression: "'alpha_spaces|min:2'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.name'))
    },
    attrs: {
      "type": "text",
      "label": "Name",
      "ico": "fa fa-user-o",
      "data-vv-name": _vm.$t('customers.attributes.name')
    },
    model: {
      value: (_vm.$parent.$data.name),
      callback: function($$v) {
        _vm.$parent.$data.name = $$v
      },
      expression: "$parent.$data.name"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customers.attributes.name')) + "\n          "), (_vm.errors.has(_vm.$t('customers.attributes.name'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.name'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.name')) && _vm.$parent.$data.name) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row d-flex align-items-center ls-lg-margin-bottom"
  }, [_c('h3', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('customers.main.customer_location')))])]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex align-items-center"
  }, [_c('MaterialInput', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('99.999-999'),
      expression: "'99.999-999'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:10|cep'),
      expression: "'required|min:10|cep'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.address.postal_code'))
    },
    attrs: {
      "type": "tel",
      "maxlength": "10",
      "ico": "fa fa-map-pin",
      "data-vv-name": _vm.$t('customers.attributes.address.postal_code')
    },
    model: {
      value: (_vm.$parent.$data.postalCode),
      callback: function($$v) {
        _vm.$parent.$data.postalCode = $$v
      },
      expression: "$parent.$data.postalCode"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customers.attributes.address.postal_code')) + "\n          "), (_vm.errors.has(_vm.$t('customers.attributes.address.postal_code'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.address.postal_code'))))]) : _vm._e(), _vm._v(" "), (_vm.showAddressDetails) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-12 margin-postal-code"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://www.buscacep.correios.com.br/sistemas/buscacep/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('settings.main.forgot_zipcode')))])])])], 1), _vm._v(" "), (_vm.showAddressDetails) ? _c('div', [_c('div', {
    staticClass: "row d-flex align-items-center"
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-8 col-sm-8 ls-no-padding"
  }, [_c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.address.street'))
    },
    attrs: {
      "type": "text",
      "ico": "fa icon icon-house",
      "data-vv-name": _vm.$t('customers.attributes.address.street'),
      "focused": _vm.focusStreet
    },
    model: {
      value: (_vm.$parent.$data.street),
      callback: function($$v) {
        _vm.$parent.$data.street = $$v
      },
      expression: "$parent.$data.street"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('customers.attributes.address.street')) + "\n              "), (_vm.errors.has(_vm.$t('customers.attributes.address.street'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.address.street'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.address.street')) && _vm.$parent.$data.street.length) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-4 col-sm-4 ls-no-padding-right"
  }, [_c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.address.number'))
    },
    attrs: {
      "type": "tel",
      "maxlength": "10",
      "ico": "fa icon icon-number",
      "data-vv-name": _vm.$t('customers.attributes.address.number'),
      "focused": _vm.focusNumber
    },
    model: {
      value: (_vm.$parent.$data.number),
      callback: function($$v) {
        _vm.$parent.$data.number = $$v
      },
      expression: "$parent.$data.number"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('customers.attributes.address.number')) + "\n              "), (_vm.errors.has(_vm.$t('customers.attributes.address.number'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.address.number'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.address.number')) && _vm.$parent.$data.number.length) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.address.neighborhood'))
    },
    attrs: {
      "type": "tel",
      "ico": "fa icon icon-neighborhood",
      "data-vv-name": _vm.$t('customers.attributes.address.neighborhood'),
      "focused": _vm.focusNeighborhood
    },
    model: {
      value: (_vm.$parent.$data.neighborhood),
      callback: function($$v) {
        _vm.$parent.$data.neighborhood = $$v
      },
      expression: "$parent.$data.neighborhood"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('customers.attributes.address.neighborhood')) + "\n            "), (_vm.errors.has(_vm.$t('customers.attributes.address.neighborhood'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.address.neighborhood'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.address.neighborhood')) && _vm.$parent.$data.neighborhood.length) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('MaterialInput', {
    attrs: {
      "type": "text",
      "name": "complement",
      "ico": "fa icon icon-cityscape",
      "required": false
    },
    model: {
      value: (_vm.$parent.$data.complement),
      callback: function($$v) {
        _vm.$parent.$data.complement = $$v
      },
      expression: "$parent.$data.complement"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('customers.attributes.address.complement')) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row d-flex align-items-center"
  }, [_c('div', {
    staticClass: "col-md-8 col-sm-8 col-xs-8 ls-no-padding"
  }, [_c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.address.city'))
    },
    attrs: {
      "type": "text",
      "ico": "fa icon icon-cityscape",
      "data-vv-name": _vm.$t('customers.attributes.address.city'),
      "focused": _vm.focusCity
    },
    model: {
      value: (_vm.$parent.$data.city),
      callback: function($$v) {
        _vm.$parent.$data.city = $$v
      },
      expression: "$parent.$data.city"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('customers.attributes.address.city')) + "\n              "), (_vm.errors.has(_vm.$t('customers.attributes.address.city'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.address.city'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.address.city')) && _vm.$parent.$data.city.length) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-4 col-sm-4 ls-no-padding-right"
  }, [_c('MaterialInput', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'material--active material--has-errors': _vm.errors.has(_vm.$t('customers.attributes.address.state'))
    },
    attrs: {
      "type": "select",
      "ico": "fa icon icon-state",
      "focused": _vm.focusState,
      "data-vv-name": _vm.$t('customers.attributes.address.state')
    },
    model: {
      value: (_vm.$parent.$data.state),
      callback: function($$v) {
        _vm.$parent.$data.state = $$v
      },
      expression: "$parent.$data.state"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('customers.attributes.address.state')) + "\n              "), _c('option', {
    attrs: {
      "value": "AC"
    },
    slot: "options"
  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    },
    slot: "options"
  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AP"
    },
    slot: "options"
  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AM"
    },
    slot: "options"
  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    },
    slot: "options"
  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CE"
    },
    slot: "options"
  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DF"
    },
    slot: "options"
  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    },
    slot: "options"
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GO"
    },
    slot: "options"
  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    },
    slot: "options"
  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    },
    slot: "options"
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    },
    slot: "options"
  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MT"
    },
    slot: "options"
  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    },
    slot: "options"
  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    },
    slot: "options"
  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PR"
    },
    slot: "options"
  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    },
    slot: "options"
  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PI"
    },
    slot: "options"
  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    },
    slot: "options"
  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RN"
    },
    slot: "options"
  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RS"
    },
    slot: "options"
  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RO"
    },
    slot: "options"
  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    },
    slot: "options"
  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    },
    slot: "options"
  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SP"
    },
    slot: "options"
  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    },
    slot: "options"
  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TO"
    },
    slot: "options"
  }, [_vm._v("TO")]), _vm._v(" "), (_vm.errors.has(_vm.$t('customers.attributes.address.state'))) ? _c('small', {
    staticClass: "material-errors",
    slot: "help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('customers.attributes.address.state'))))]) : _vm._e(), _vm._v(" "), (!_vm.errors.has(_vm.$t('customers.attributes.address.state')) && _vm.$parent.$data.state.length) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "ico-check"
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "ls-actions-btn"
  }, [_c('div', {
    staticClass: "ls-float-right"
  }, [_c('router-link', {
    staticClass: "ls-btn",
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.cancel')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn ls-btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.save')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79d52a21"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/customers/components/Form.vue
// module id = 807
// module chunks = 1